import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import Session from "Session";
import AssetModel from "src/profiles/view/AssetModel";
import PersonModel from "src/shared/persons/PersonModel";
import programService from "src/shared/program-picker/program-service";
import notificationService from "src/shared/notification/notification-service";
import MeAssetModel from "src/profiles/view/MeAssetModel";
import { personChangeEvent } from "src/shared/store/event-bus/person";

const POLLING_TIME_IN_MILLISECONDS = 500;
const MAX_POLLING_TIME_IN_MILLISECONDS = 60000;

const STATUSES = {
    APPROVED: "APPROVED",
    PENDING_REVIEW: "PENDING_REVIEW",
    DENIED: "DENIED",
};
function UploadPersonAssetService() {
    this.startPolling = function (response) {
        const assetModel = new AssetModel({
            personId: this.model.get("id"),
            assetId: response.id,
        });
        const deferred = $.Deferred();
        this.timeInMilliseconds = 0;
        this.poll(assetModel, deferred);
        return deferred;
    };

    this.poll = function (assetModel, deferred) {
        this.timeout = setTimeout(
            this.getAsset.bind(this, assetModel, deferred),
            POLLING_TIME_IN_MILLISECONDS
        );
    };

    this.getAsset = function (assetModel, deferred) {
        const self = this;
        if (this.timeInMilliseconds >= MAX_POLLING_TIME_IN_MILLISECONDS) {
            deferred.reject();
            return;
        }
        $.when(assetModel.fetch())
            .done((asset) => {
                if (asset.status === STATUSES.PENDING_REVIEW) {
                    self.timeInMilliseconds += POLLING_TIME_IN_MILLISECONDS;
                    self.poll(assetModel, deferred);
                } else if (asset.status === STATUSES.APPROVED) {
                    deferred.resolve(asset);
                    programService
                        .findDefaultProgramDomainService()
                        .done((programDomain) => {
                            const meAssetModel = new MeAssetModel(null, {
                                assetId: asset.id,
                                email: self.model.get("email"),
                                defaultDomain: programDomain,
                            });
                            meAssetModel.fetchAsset().then(() => {
                                if (meAssetModel.get("status") === "APPROVED") {
                                    const pictureUrl = `https://${programDomain}/web/persons/${self.model.get(
                                        "id"
                                    )}/assets/${asset.id}/download`;
                                    self.model.set("picture_url", pictureUrl);
                                    self.model.trigger("upload");
                                }
                            });
                        });
                } else {
                    deferred.reject();
                }
            })
            .fail(() => {
                notificationService.error(
                    "Sorry, your person image was denied"
                );
                deferred.reject();
            });
    };

    this.uploadAsset = function (model, file) {
        this.model = model;
        let { urlRoot } = model;
        const formData = new FormData();
        const deferred = $.Deferred();
        formData.append("file", file, file.name);
        const assetJSON = JSON.stringify({
            name: file.name,
            tags: [],
            data_type: "PUBLIC",
        });
        formData.append("asset", assetJSON);
        if (urlRoot !== "api:///v2/persons") {
            urlRoot = "api:///v2/persons";
        }
        return Backbone.ajax({
            url: `${urlRoot}/${model.get("id")}/assets`,
            type: "POST",
            processData: false,
            contentType: false,
            data: formData,
        })
            .then(this.startPolling.bind(this))
            .done(deferred.resolve)
            .fail(deferred.reject);
    };

    this.uploadPersonAsset = function (personId, file) {
        const person = PersonModel.create(personId);
        return this.uploadAsset(person, file);
    };
}

export default new UploadPersonAssetService();
